import React, { useEffect, useState } from "react";
import { getFieldData, getFormatedNumber } from "../../Services/appService";
import Moment from "react-moment";
import { getCurrentUser, getLoggedUserDetails, loadUserDetails } from "../store/auth";
import { useDispatch, useSelector } from "react-redux";
import { getPartnerDetails } from "../store/partner";
import { getAppTasks, getCandidateApps, loadAppRuningTasks, loadCandidateApps } from "../store/candidate";

const PARTNER_INFO_STYLES = {
    shell: {
        background: "linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)",
        border: "1px solid rgba(203, 213, 225, 0.9)",
        borderRadius: "18px",
        boxShadow: "0 10px 26px rgba(15, 23, 42, 0.05)",
        overflow: "hidden"
    },
    hero: {
        padding: "10px 18px 10px 18px",
        background: "linear-gradient(135deg, #eff6ff 0%, #f8fafc 55%, #ffffff 100%)",
        borderBottom: "1px solid rgba(203, 213, 225, 0.8)",
        // minHeight: "74px",
        display: "flex",
        alignItems: "center"
    },
    heroRow: {
        display: "flex",
        justifyContent: "space-between",
        gap: "18px",
        flexWrap: "wrap",
        alignItems: "center",
        width: "100%"
    },
    heroCopy: {
        display: "flex",
        flexDirection: "column",
        gap: "6px",
        minWidth: "220px",
        flex: 1,
        justifyContent: "center"
    },
    eyebrow: {
        fontSize: "10px",
        fontWeight: 700,
        letterSpacing: "0.12em",
        textTransform: "uppercase",
        color: "#2563eb"
    },
    title: {
        fontSize: "22px",
        fontWeight: 700,
        lineHeight: 1.1,
        color: "#0f172a",
        margin: 0,
        textTransform: "uppercase"
    },
    subtitle: {
        fontSize: "13px",
        color: "#475569",
        margin: 0,
        maxWidth: "720px"
    },
    badgeRow: {
        display: "flex",
        gap: "10px",
        flexWrap: "wrap",
        alignItems: "center"
    },
    badge: {
        display: "inline-flex",
        alignItems: "center",
        gap: "8px",
        padding: "7px 11px",
        borderRadius: "999px",
        backgroundColor: "#ffffff",
        border: "1px solid rgba(191, 219, 254, 1)",
        color: "#1d4ed8",
        fontSize: "11px",
        fontWeight: 700,
        boxShadow: "0 6px 18px rgba(37, 99, 235, 0.08)"
    },
    grid: {
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(190px, 1fr))",
        gap: "12px",
        padding: "14px 18px 18px 18px"
    },
    card: {
        backgroundColor: "#ffffff",
        border: "1px solid rgba(226, 232, 240, 1)",
        borderRadius: "16px",
        padding: "12px 14px",
        minHeight: "100%",
        boxShadow: "0 8px 24px rgba(15, 23, 42, 0.04)"
    },
    cardLabel: {
        fontSize: "10px",
        fontWeight: 700,
        letterSpacing: "0.12em",
        textTransform: "uppercase",
        color: "#64748b",
        marginBottom: "8px"
    },
    primaryText: {
        fontSize: "15px",
        fontWeight: 700,
        lineHeight: 1.25,
        color: "#0f172a",
        marginBottom: "4px",
        wordBreak: "break-word"
    },
    secondaryText: {
        fontSize: "13px",
        lineHeight: 1.45,
        color: "#475569",
        marginBottom: "2px",
        wordBreak: "break-word"
    },
    statValue: {
        fontSize: "22px",
        fontWeight: 700,
        lineHeight: 1,
        color: "#0f172a",
        marginBottom: "6px"
    },
    emptyText: {
        fontSize: "13px",
        color: "#94a3b8",
        margin: 0
    }
};

export default function PartnerInfo() {

    const [partnerDetails, setPartnerDetails] = useState(null);
    const [wfTask, setWfTask] = useState(null);

    const userDetailsSelector = useSelector(getLoggedUserDetails);
    const partnerDetailsSelector = useSelector(getPartnerDetails);
    const candidateAppsSelector = useSelector(getCandidateApps);
    const appTasksSelector = useSelector(getAppTasks);

    const currentUser = getCurrentUser();
    const dispatch = useDispatch();

    useEffect(() => {
        let usrId = currentUser.id;
        if (currentUser.linkUser)
            usrId = currentUser.linkUser;

        if (!userDetailsSelector)
            dispatch(loadUserDetails(usrId));

        if (candidateAppsSelector.length === 0 && currentUser?.id > 0)
            dispatch(loadCandidateApps(usrId))
    }, []);

    // useEffect(() => {
    //     console.log("partnerDetailsSelector", partnerDetailsSelector);
    //     if (userDetailsSelector?.partnerid && !partnerDetailsSelector) {
    //         dispatch(loadPartnerDetails(userDetailsSelector.partnerid))
    //     }
    // }, [userDetailsSelector]);

    useEffect(() => {
        if (candidateAppsSelector.length > 0 && currentUser?.id > 0) {
            const mainWorkflow = candidateAppsSelector.filter(x => x.workflowType === 1);
            if (mainWorkflow.length > 0) {
                const wf = mainWorkflow[0];
                let usrId = currentUser.id;
                if (currentUser.linkUser)
                    usrId = currentUser.linkUser;
                if (currentUser?.id > 0) {
                    dispatch(loadAppRuningTasks(wf.oldWorkflowId, usrId));
                }

            }
        }
    }, [candidateAppsSelector]);

    useEffect(() => {
        if (appTasksSelector.length > 0) {
            const filterTasks = appTasksSelector.filter(x => x.taskType === 1 && x.wiid > 0);
            if (filterTasks.length > 0)
                setWfTask(filterTasks[0]);
        }
    }, [appTasksSelector]);

    useEffect(() => {
        setPartnerDetails(partnerDetailsSelector);
    }, [partnerDetailsSelector]);

    const usrType = localStorage.getItem("userType");

    const getPartnerTypeLabel = () => {
        if (!usrType) return "Partner";
        return usrType.charAt(0).toUpperCase() + usrType.slice(1);
    };

    const getCompanyEmail = () => {
        if (!wfTask) return "";
        if (usrType === "recruiter") {
            return getFieldData(wfTask.stateData, "recruiterenrollmentform", "Company_Email");
        }
        if (usrType === "subcontractor") {
            return getFieldData(wfTask.stateData, "subcontractorenrollmentform", "Company_Email");
        }
        return "";
    };

    const getCompanyPhone = () => {
        if (!wfTask) return "";
        if (usrType === "recruiter") {
            return getFormatedNumber(getFieldData(wfTask.stateData, "recruiterenrollmentform", "Company_Phone"));
        }
        if (usrType === "subcontractor") {
            return getFormatedNumber(getFieldData(wfTask.stateData, "subcontractorenrollmentform", "Company_Phone"));
        }
        return "";
    };

    const renderAddressLines = () => {
        if (!wfTask) {
            return <p style={PARTNER_INFO_STYLES.emptyText}>Address information will appear here once the enrollment workflow is available.</p>;
        }

        let ddType = "recruiterenrollmentform";
        if (usrType === "subcontractor") ddType = "subcontractorenrollmentform";

        const lines = [
            getFieldData(wfTask.stateData, ddType, "Company_Address_Line1"),
            getFieldData(wfTask.stateData, ddType, "Company_Address_Line2")
        ].filter(Boolean);
        const city = getFieldData(wfTask.stateData, ddType, "Company_City");
        const state = getFieldData(wfTask.stateData, ddType, "Company_State");
        const zip = getFieldData(wfTask.stateData, ddType, "Company_Zip_Code");
        const country = getFieldData(wfTask.stateData, ddType, "Company_Country");
        const locationLine = [city, state, country, zip].filter(Boolean).join(", ");

        if (lines.length === 0 && !locationLine && !country) {
            return <p style={PARTNER_INFO_STYLES.emptyText}>No address on file.</p>;
        }

        return <>
            {lines.map((line, index) => (
                <div key={index} style={PARTNER_INFO_STYLES.secondaryText}>{line}</div>
            ))}
            {locationLine && <div style={PARTNER_INFO_STYLES.secondaryText}>{locationLine}</div>}
            {country && <div style={PARTNER_INFO_STYLES.secondaryText}>{country}</div>}
        </>;
    };

    let item = "";
    if (partnerDetails)
        item = partnerDetails;

    return <React.Fragment>
        <div style={PARTNER_INFO_STYLES.shell}>
            <div style={PARTNER_INFO_STYLES.hero}>
                <div style={PARTNER_INFO_STYLES.heroRow}>
                    <div style={PARTNER_INFO_STYLES.heroCopy}>
                        <h2 style={PARTNER_INFO_STYLES.title}>{item !== "" ? item.label : "Partner information"}</h2>
                    </div>
                    <div style={PARTNER_INFO_STYLES.badgeRow}>
                        <span style={PARTNER_INFO_STYLES.badge}>
                            <i className="fa fa-id-badge" aria-hidden="true"></i>
                            ID: {item !== "" ? item.fuid : "--"}
                        </span>
                        <span style={PARTNER_INFO_STYLES.badge}>
                            <i className="fa fa-users" aria-hidden="true"></i>
                            Total Users: {item !== "" && item.activeUsers !== undefined ? item.activeUsers : 0}
                        </span>
                        <span style={PARTNER_INFO_STYLES.badge}>
                            <i className="fa fa-calendar" aria-hidden="true"></i>
                            Registration: {item !== "" ? <><Moment format="MMM Do YYYY">{item.createdDate}</Moment>{" | "}<Moment format="h:mm a">{item.createdDate}</Moment></> : "--"}
                        </span>
                    </div>
                </div>
            </div>

            <div style={PARTNER_INFO_STYLES.grid}>
                <div style={PARTNER_INFO_STYLES.card}>
                    <div style={PARTNER_INFO_STYLES.cardLabel}>Company Details</div>
                    {item !== "" ? <>
                        <div style={PARTNER_INFO_STYLES.secondaryText}>{getCompanyEmail() || "No company email on file."}</div>
                        <div style={PARTNER_INFO_STYLES.secondaryText}>{getCompanyPhone() || "No company phone on file."}</div>
                    </> : <p style={PARTNER_INFO_STYLES.emptyText}>Partner details are loading.</p>}
                </div>

                <div style={PARTNER_INFO_STYLES.card}>
                    <div style={PARTNER_INFO_STYLES.cardLabel}>Address</div>
                    {renderAddressLines()}
                </div>

                <div style={PARTNER_INFO_STYLES.card}>
                    <div style={PARTNER_INFO_STYLES.cardLabel}>Key Contact</div>
                    {item !== "" && item.contact1 ? <>
                        <div style={PARTNER_INFO_STYLES.primaryText}>
                            {item.contact1.performername} {item.contact1.lastName}
                        </div>
                        <div style={PARTNER_INFO_STYLES.secondaryText}>{item.contact1.performeremail || "No email on file."}</div>
                        <div style={PARTNER_INFO_STYLES.secondaryText}>
                            {item?.contact1?.contactNo ? getFormatedNumber(item.contact1.contactNo) : "No phone on file."}
                        </div>
                    </> : <p style={PARTNER_INFO_STYLES.emptyText}>No primary contact has been assigned yet.</p>}
                </div>
            </div>
        </div>
    </React.Fragment>
}
